// Adapts an invoice as returned by the API (snake_case, items in a separate
// array) into the shape InvoiceA4Document expects, which is the create form's
// state shape. This lets the create form, the view page and the standalone
// preview tab all feed one document component.

// The API returns DATE columns as either 'YYYY-MM-DD' or a full ISO timestamp
// depending on the driver; the document only ever wants 'YYYY-MM-DD'.
const toDateInput = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value.slice(0, 10);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 10);
};

export const invoiceToDocument = (invoice = {}, items = []) => ({
  invoiceNumber: invoice.invoice_number || '',
  date: toDateInput(invoice.date || invoice.invoice_date),
  currency: invoice.currency || 'ден',
  notes: invoice.note || invoice.notes || '',
  // Outgoing invoices bill the partner, so the partner is the "ДО" side.
  toCompanyName: invoice.customer_name || invoice.partner_name || '',
  toCompanyAddress: invoice.address || invoice.partner_address || '',
  toCompanyPhone: invoice.phone || '',
  fromCompanyName: invoice.from_company_name || '',
  items: items.map((item, index) => ({
    id: item.id ?? index,
    // The document filters on `name`, so fall back through the fields the
    // various item endpoints use before giving up.
    name: item.product_name || item.name || item.description || '',
    quantity: item.quantity ?? '',
    // invoice_items has no unit column; the document falls back to 'пар.'
    unit: item.unit || '',
    price: item.price ?? item.unit_price ?? 0,
  })),
});
